import React from 'react'
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core'
import { Controller, useFormContext } from 'react-hook-form'

import constants from 'constants/index'
import useStyles from './styles'

const IncidentReportFormat = () => {
  const classes = useStyles()
  const { control, errors, clearError } = useFormContext()

  const { SIMPLIFIED_FORM_LIST } = constants.incidents

  return (
    <>
      <InputLabel className={classes.label}>Formato do relatório:</InputLabel>
      <FormControl component="fieldset" error={!!errors.simplifiedForm}>
        <Controller
          name="simplifiedForm"
          control={control}
          defaultValue=""
          as={
            <RadioGroup>
              {SIMPLIFIED_FORM_LIST.map((format) => (
                <FormControlLabel
                  key={format.value}
                  value={format.value}
                  control={<Radio classes={{ checked: classes.checked }} />}
                  className={classes.radioLabel}
                  label={format.name}
                />
              ))}
            </RadioGroup>
          }
          onChange={([event]) => {
            clearError('simplifiedForm')
            return event.target.value
          }}
        />
        {!!errors.simplifiedForm && (
          <FormHelperText error>{errors.simplifiedForm.message}</FormHelperText>
        )}
      </FormControl>
    </>
  )
}

export default IncidentReportFormat
